module.exports = __webpack_public_path__ + "img/nigeria.fe15d89d.svg";